import { lazy } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';
export const ThirdPartyCardConnector = withAsync({
    loader: lazy(() => import(/* webpackChunkName: 'kb-thirdparty-connectors' */ './connectors/index')),
});
